module.exports = __webpack_public_path__ + "img/Steve_F_Circle.39ba3245.png";